/**
 * Design Tokens for Weidner Apartment Homes Theme
 * 
 * Extends the base blue-haven theme tokens with Weidner Apartment Homes branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-blue-haven/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Weidner Apartment Homes brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Weidner Apartment Homes brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Weidner Apartment Homes typography - customize these
    // heading: '"Your Heading Font", serif',
    // body: '"Your Body Font", sans-serif',
  },
};

export default tokens;
